<template>
  <div
    class="statusWarp"
    v-if="initData.AdStatus"
  >
    <span
      v-if="row.effective_status != 'DELETED' && row.effective_status != 'ARCHIVED'"
      :class="['pointer', row.effective_status]"
    ></span>
    <span :class="['name', `name${row.status}`]">
      <div
        v-if="row.level !== 'campaign'"
        class="status-name"
      >
        <!-- 广告层级展示拒登原因 -->
        <div v-if="row.approvalStatus && row.level == 'ad'">
          <p class="text-[#ff0000]">
            {{ row.approvalStatus.approvalStatus }}
          </p>
          <el-tooltip
            effect="light"
            placement="top"
            :disabled="!Object.keys(row.approvalStatus.topicPolicy).length"
          >
            <div slot="content">
              <div v-for="item in row.approvalStatus.topics">
                <p class="text-[14px]">{{ item }}</p>
                <p
                  v-for="item1 in row.approvalStatus.topicPolicy[item]"
                  class="ml-[10px] my-[5px] text-[13px]"
                >
                  · {{ item1 }}
                </p>
              </div>
            </div>
            <span :class="['text-[#333]', Object.keys(row.approvalStatus.topicPolicy).length] ? 'underline' : ''">{{
              row.approvalStatus.topics.join('、')
            }}</span>
          </el-tooltip>
        </div>
        <p v-else>{{ statusDesc }}</p>
      </div>
      <div
        v-if="row.level === 'campaign' && row.primary_status_reasons"
        class="status-name"
      >
        <div
          :class="{
            'bid-status': row.hasRecommend,
            'budget-status': row.hasRecommend,
          }"
          @click="$emit('open-ai-suggestion', row)"
        >
          {{ row?.primary_status_reasons }}
        </div>
      </div>
    </span>
    <el-tooltip
      v-if="row.status_hints && row.status_hints.length"
      placement="bottom"
      width="600"
      trigger="hover"
      :enterable="true"
      effect="light"
      popper-class="rule-tip"
    >
      <div slot="content">
        <div
          class="rule-score-wrap"
          v-for="(item, index) in row.status_hints"
          :key="index"
        >
          <div>
            <i
              class="el-icon-warning"
              v-if="item.level == 'WARN'"
            ></i>
            <i
              class="el-icon-error"
              v-if="item.level == 'ERROR'"
            ></i>
            <span>{{ item.message }}</span>
          </div>
          <div
            v-if="item.alertId"
            style="margin-left: 5px"
          >
            <el-button
              v-if="item.alertScore == null || item.alertScore == 1"
              type="text"
              size="mini"
              :disabled="item.alertScore == 1"
              @click="$emit('review-score', { row, item, index, flag: 1 })"
            >
              准确
            </el-button>
            <el-button
              v-if="item.alertScore == null || item.alertScore === 0"
              type="text"
              size="mini"
              :disabled="item.alertScore === 0"
              @click="$emit('review-score', { row, item, index, flag: 0 })"
            >
              不准确
            </el-button>
          </div>
        </div>
      </div>
      <i class="el-icon-info"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'StatusCell',
  props: {
    row: {
      type: Object,
      required: true,
    },
    initData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusDesc() {
      const status = this.initData.AdStatus?.find((v) => v.key === this.row.effective_status);
      return status?.desc || this.row.effective_status || '--';
    },
  },
};
</script>

<style lang="scss" scoped>
.ACTIVE {
  background: #67c23a;
}

.PAUSED,
.IN_PROCESS {
  background: #e6a23c;
}

.DELETED {
  background: #f56c6c;
}

.DISAPPROVED {
  background: #ff0000;
}

.PREAPPROVED,
.ARCHIVED {
  background: #409eff;
}

.WITH_ISSUES,
.PENDING_BILLING_INFO,
.ADSET_PAUSED {
  background: #f56c6c;
}

.PENDING_REVIEW,
.CAMPAIGN_PAUSED {
  background: #909399;
}

.status-name {
  margin-left: 5px;
}

.bid-status {
  padding: 4px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  background: rgb(254, 247, 224);
  color: rgb(215, 118, 24);
  font-size: 14px;
  margin-top: 3px;
}

.budget-status {
  padding: 4px 12px;
  box-sizing: border-box;
  border-radius: (252, 232, 230);
  color: rgb(199, 39, 34);
  font-size: 14px;
}
.common-status {
  margin-left: 5px;
}
</style>
